export enum Partitions {
    ADDRESS = 'Address',
    USERS = 'Users',
    DIRECTORIES = 'Directories',
    FINAL_DISPOSITION = 'FinalDisposition',

    AREA = 'AreaOperation',
    GENERALCONFIG = 'GeneralConfigOperation',
    CUSTOMER = 'CustomerOperation',
    POLICY = 'PolicyOperation',
    ROLE = 'RoleOperation',
    CERTIFICATE = 'SignOperation',
    //FILESIGNATURE = 'Queue/FileSignature',
    FILESIGNATURE = 'SignOperation/ExecuteNewRequest',
    CERTIFICATESTATUS = 'CertificateStatusOperation',
    CERTIFICATETYPE = 'CertificateTypesOperation',

    //Authorization
    ACTIONSAZURECEC = "Action",
    ALLOWSAZURECEC = "Allow",
    GROUPSAZURECEC = 'Group',
    ROLESAZURECEC = 'Role',
    RESOURCESAZURECEC = "Resource",
    ACTIONSBYROLESAZURECEC = "ActionsByRoles",
    USERSBYGROUPSAZURECEC = "UserByGroup",

    //Authorization --> Endpoints
    ACTIONSAZURE = "ActionAzure",
    ALLOWSAZURE = "AllowAzure",
    GROUPSAZURE = 'GroupAzure',
    RESOURCESAZURE = "ResourceAzure",
    ROLESAZURE = 'RoleAzure',
    ACTIONSBYROLESAZURE = "ActionsByRolesAzure",
    USERSBYGROUPSAZURE = "UserByGroupAzure",
}
